"use client";
import "@repo/edtech-ui-kit/styles";
import "@repo/edtech-player-manager/styles";
import { jsxs as l, jsx as o, Fragment as z } from "react/jsx-runtime";
import { useState as O, useRef as D, useEffect as Y } from "react";
import { useFileSize as q, EdtechProvider as G } from "@repo/edtech-shared";
import { CircularProgress as J, PlayPauseButton as K, PlayerProgressBar as Q, SettingsButton as U } from "@repo/edtech-ui-kit";
import { usePlayerStore as r, usePlayerAllActions as P, convertBytesToMb as S, PlayerType as u, PlayerFileType as I, PLAYER_SPEED as W, getPlayIcon as X, formatToHHMMSS as Z } from "@repo/edtech-video-player-utils";
import { ArrowDownAndBracketTrailingIcon as oo, CheckmarkIcon as so, PauseIcon as eo, SmallPlayIcon as no, CrossIcon as E } from "@repo/edtech-assets";
function V(s) {
  var c, n, e = "";
  if (typeof s == "string" || typeof s == "number") e += s;
  else if (typeof s == "object") if (Array.isArray(s)) {
    var m = s.length;
    for (c = 0; c < m; c++) s[c] && (n = V(s[c])) && (e && (e += " "), e += n);
  } else for (n in s) s[n] && (e && (e += " "), e += n);
  return e;
}
function k() {
  for (var s, c, n = 0, e = "", m = arguments.length; n < m; n++) (s = arguments[n]) && (c = V(s)) && (e && (e += " "), e += c);
  return e;
}
const to = "_downloader_y5bmg_1", co = "_download_block_y5bmg_7", lo = "_download_y5bmg_1", io = "_size_y5bmg_21", ro = "_progress_y5bmg_27", ao = "_controls_y5bmg_31", _o = "_controller_y5bmg_36", mo = "_active_y5bmg_49", uo = "_play_y5bmg_59", go = "_close_icon_y5bmg_65", t = {
  downloader: to,
  download_block: co,
  download: lo,
  size: io,
  progress: ro,
  controls: ao,
  controller: _o,
  active: mo,
  play: uo,
  close_icon: go
}, ho = ({
  url: s,
  fileSize: c,
  fileType: n,
  playerType: e
}) => {
  const m = r(e, (a) => a.downloadProgress), y = r(e, (a) => a.downloadedSize), g = r(e, (a) => a.isDownloading), h = r(e, (a) => a.isPaused), w = r(e, (a) => a.isCompleted), {
    startDownload: b,
    pauseDownload: i,
    cancelDownload: v
  } = P(e), N = () => b(
    s,
    c,
    n
  );
  return /* @__PURE__ */ l("div", { className: t.downloader, children: [
    !g && !h && !w && /* @__PURE__ */ l(
      "button",
      {
        className: k(
          t.download_block,
          t.download,
          t.active
        ),
        onClick: N,
        children: [
          /* @__PURE__ */ o(oo, {}),
          "Скачать",
          " ",
          /* @__PURE__ */ l("span", { className: t.size, children: [
            S(c),
            " МБ"
          ] })
        ]
      }
    ),
    /* @__PURE__ */ l("div", { className: t.download_block, children: [
      w && /* @__PURE__ */ l(z, { children: [
        /* @__PURE__ */ o("button", { className: t.controller, children: /* @__PURE__ */ o(so, {}) }),
        /* @__PURE__ */ o("span", { className: t.download, children: "Скачано" })
      ] }),
      (g || h) && /* @__PURE__ */ l(z, { children: [
        /* @__PURE__ */ o(J, { progress: m }),
        /* @__PURE__ */ l("span", { className: t.download, children: [
          "Скачивание",
          " ",
          /* @__PURE__ */ l("span", { className: t.size, children: [
            S(y),
            " из ",
            S(c),
            " МБ"
          ] })
        ] }),
        /* @__PURE__ */ l("span", { className: t.progress, children: [
          m,
          "%"
        ] })
      ] })
    ] }),
    /* @__PURE__ */ l("div", { className: t.controls, children: [
      g && !h && /* @__PURE__ */ o(
        "button",
        {
          className: t.controller,
          onClick: i,
          children: /* @__PURE__ */ o(eo, { className: k(t.play, t.active) })
        }
      ),
      h && /* @__PURE__ */ o(
        "button",
        {
          className: t.controller,
          onClick: N,
          children: /* @__PURE__ */ o(no, { className: t.play })
        }
      ),
      (g || h) && /* @__PURE__ */ o(
        "button",
        {
          className: t.controller,
          onClick: v,
          children: /* @__PURE__ */ o(E, { className: k(t.close_icon, t.active) })
        }
      )
    ] })
  ] });
}, bo = (s) => s === u.Video ? "Настройки видео" : "Настройки аудио", po = (s) => s === u.Video ? I.Video : I.Audio, wo = "_settings_h4ysn_1", yo = "_header_h4ysn_15", No = "_close_h4ysn_20", fo = "_close_icon_h4ysn_29", ko = "_settings_title_h4ysn_34", vo = "_tools_h4ysn_41", So = "_block_h4ysn_47", Po = "_block_title_h4ysn_53", Ao = "_buttons_h4ysn_60", Co = "_button_h4ysn_60", zo = "_active_h4ysn_80", _ = {
  settings: wo,
  header: yo,
  close: No,
  close_icon: fo,
  settings_title: ko,
  tools: vo,
  block: So,
  block_title: Po,
  buttons: Ao,
  button: Co,
  active: zo
}, Do = ({
  isNeedDownload: s,
  clickOutsideRef: c,
  playerType: n = u.Video,
  onClose: e
}) => {
  const m = r(n, (i) => i.speed), y = r(n, (i) => i.fileSize), g = r(n, (i) => i.source), { setSpeed: h } = P(n), w = bo(n), b = po(n);
  return /* @__PURE__ */ l(
    "div",
    {
      ref: c,
      className: _.settings,
      children: [
        /* @__PURE__ */ l("div", { className: _.header, children: [
          /* @__PURE__ */ o("h2", { className: _.settings_title, children: w }),
          /* @__PURE__ */ o(
            "button",
            {
              className: _.close,
              onClick: e,
              children: /* @__PURE__ */ o(E, { className: _.close_icon })
            }
          )
        ] }),
        /* @__PURE__ */ l("div", { className: _.tools, children: [
          /* @__PURE__ */ l("div", { className: _.block, children: [
            /* @__PURE__ */ o("h3", { className: _.block_title, children: "Скорость" }),
            /* @__PURE__ */ o("div", { className: _.buttons, children: W.map((i) => /* @__PURE__ */ o(
              "button",
              {
                className: k(_.button, m === i && _.active),
                onClick: () => h(i),
                children: i
              },
              i
            )) })
          ] }),
          s && /* @__PURE__ */ o(
            ho,
            {
              fileSize: y ?? 0,
              fileType: b,
              playerType: n,
              url: g
            }
          )
        ] })
      ]
    }
  );
}, Io = "_audio_core_1i7na_1", Eo = "_controls_1i7na_10", Vo = "_progress_wrap_1i7na_27", Bo = "_timer_1i7na_32", f = {
  audio_core: Io,
  controls: Eo,
  progress_wrap: Vo,
  timer: Bo
}, Lo = ({
  src: s,
  title: c,
  id: n,
  disabledSettings: e,
  isNeedDownload: m = !0
}) => {
  const [y, g] = O(!1), h = D(null), w = D(null), b = n, {
    setActivate: i,
    seekTo: v,
    toggle: N,
    setFileSize: a
  } = P(u.Audio), B = r(u.Audio, (d) => d.id), $ = r(u.Audio, (d) => d.playing), x = r(u.Audio, (d) => d.ended), F = r(u.Audio, (d) => d.currentTime), R = r(u.Audio, (d) => d.duration), p = B === b, j = p && $, M = p && x, A = p ? F : 0, T = p ? R : 0, C = q(s), H = () => {
    p ? N() : i({
      id: b,
      source: s,
      autoplay: !0,
      title: c
    });
  }, L = () => {
    g((d) => !d);
  };
  return Y(() => {
    a(C);
  }, [
    C,
    p,
    a
  ]), /* @__PURE__ */ o(G, { name: "audio-player", children: /* @__PURE__ */ o(
    "div",
    {
      className: f.audio_core,
      "data-audio-slot": b,
      children: /* @__PURE__ */ l("div", { className: f.controls, children: [
        /* @__PURE__ */ o(
          K,
          {
            Icon: X(j, M),
            onClick: H
          }
        ),
        /* @__PURE__ */ o("div", { className: f.progress_wrap, children: /* @__PURE__ */ o(
          Q,
          {
            currentTime: A,
            duration: T,
            seekTo: p ? v : () => null
          }
        ) }),
        /* @__PURE__ */ o("span", { className: f.timer, children: Z(A) }),
        /* @__PURE__ */ o(
          U,
          {
            disabled: !!e,
            triggerRef: h,
            onClick: L
          }
        ),
        y && /* @__PURE__ */ o(
          Do,
          {
            clickOutsideRef: w,
            isNeedDownload: m,
            playerType: u.Audio,
            onClose: () => g(!1)
          }
        )
      ] })
    }
  ) });
};
export {
  Lo as EdtechAudioPlayer
};
